export default "__VITE_ASSET__Dlkg6wC8__"